import styled from 'styled-components';
import { ProductLinkedProductsValuesAttribute } from 'src/models/pim/attributes';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { Paragraph } from 'src/components/common/typography/Text';
import { PimImage } from 'src/components/common/PimImage';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';

const Container = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1rpx solid ${({ theme }) => theme.skeleton.base};
`;

const Name = styled(Paragraph)`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
`;

const Description = styled(Paragraph)`
  font-size: 13px;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 64px;
  height: 64px;
`;

export const ProductPageProtocolsSessionsItemProduct = ({
  products_id,
}: ProductLinkedProductsValuesAttribute['item']['value'][number]) => {
  const product = useTranslateItem(products_id);

  const description = product.tagline ?? product.description_short;

  return (
    <Container>
      <ImageContainer>
        {product.image && (
          <PimImage
            src={product.image.id}
            layout="fill"
            objectFit="contain"
            sizes="100vw"
          />
        )}
      </ImageContainer>

      <div>
        <Name>{product.name}</Name>

        {description && (
          <Description>
            <Markdown>{description}</Markdown>
          </Description>
        )}
      </div>
    </Container>
  );
};
